var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('theme-editor',{attrs:{"slot":"main","novelId":_vm.novelId},slot:"main"})}
var staticRenderFns = []

export { render, staticRenderFns }